import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-top-section">
          <div className="footer-cta">
            <h2 className="footer-title">HAVE ANY PROJECT<br/>IDEA? CONTACT ME</h2>
            <Link to="/contact" className="btn btn-black">Contact Now <span className="btn-arrow">→</span></Link>
          </div>

          <div className="footer-links-grid">
            <div className="footer-column">
              <h4>MAIN PAGES</h4>
              <ul>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About</Link></li>
                <li><Link to="/projects">Project</Link></li>
              </ul>
            </div>
            <div className="footer-column">
              <h4>UTILITY PAGES</h4>
              <ul>
                <li><Link to="/licenses">Licenses</Link></li>
              </ul>
            </div>
            <div className="footer-column">
              <h4>MORE PAGES</h4>
              <ul>
                <li><Link to="/services">Services</Link></li>
                <li><Link to="/contact">Contact</Link></li>
              </ul>
            </div>
            <div className="footer-column">
              <h4>SOCIALS</h4>
              <ul>
                <li><a href="https://www.instagram.com/anshchopra_21/" target="_blank" rel="noopener noreferrer">Instagram</a></li>
                <li><a href="https://www.linkedin.com/in/anshchopra26/" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
                <li><a href="https://drive.google.com/file/d/1iKpM8X_K9XL1n_9z4VjmfrP6CrCsnZzU/view?usp=sharing" target="_blank" rel="noopener noreferrer">Resume</a></li>
                <li><a href="https://drive.google.com/file/d/1FiHJFm0p5etaPDE3h3g-dsKTAGkeJ0xY/view?usp=sharing" target="_blank" rel="noopener noreferrer">UI/UX Resume</a></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>Copyright @ Ansh Chopra. All Rights Reserved</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
